export enum UserPermission {
  None = '',
  Admin = 'admin',
  Editor = 'editor',
  ReadOnly = 'readonly',
}

export enum ProvisionChannel {
  Direct = 'direct',
  DomainSafelist = 'domain_safelist',
  Invited = 'invited',
  SSO = 'sso',
}

export interface ProjectPermission {
  _id?: string;
  fromGroup?: boolean;
  groupName?: string;
  project: any;
  provision_channel?: ProvisionChannel;
  userType: TUserPermission;
}

// This type allows consumers to pass in the literal string value of the enum,
// mostly to support legacy code
export const TUserPermission = {
  Admin: 'admin',
  None: '',
  ReadOnly: 'readonly',
  Editor: 'editor',
} as const;

export type TUserPermission = (typeof TUserPermission)[keyof typeof TUserPermission] | UserPermission;

export type PermissionVerbage =
  | 'Admin'
  | 'Editor'
  | 'Group Admin'
  | 'Group Editor'
  | 'Group Viewer'
  | 'No Access'
  | 'Viewer';

export const verbageToTypes: Record<PermissionVerbage, ProjectPermission['userType']> = {
  'No Access': '',
  'Group Viewer': 'readonly',
  'Group Editor': 'editor',
  Viewer: 'readonly',
  'Group Admin': 'admin',
  Admin: 'admin',
  Editor: 'editor',
};

export const groupTypesToVerbage: Record<TUserPermission, PermissionVerbage> = {
  [TUserPermission.None]: 'No Access',
  [TUserPermission.ReadOnly]: 'Group Viewer',
  [TUserPermission.Admin]: 'Group Admin',
  [TUserPermission.Editor]: 'Group Editor',
};

export const typesToVerbage: Record<TUserPermission, PermissionVerbage> = {
  [TUserPermission.None]: 'No Access',
  [TUserPermission.ReadOnly]: 'Viewer',
  [TUserPermission.Admin]: 'Admin',
  [TUserPermission.Editor]: 'Editor',
};

export enum LoginType {
  CUSTOM_JWT = 'custom-jwt',
  OAUTH = 'oauth',
  README = 'readme',
  SAML = 'saml',
}

/**
 * Feature flag for rendering OAuth Flows in the API Explorer.
 *
 * If `legacy-enabled`, the project contains an OAuth URL, and an "Authorize" button should be displayed above the
 * OAuth input.
 *
 * If `enabled`, the OAuth flows UI should be displayed.
 *
 * If `false`, no OAuth UI should be displayed.
 */
export type OAuthFeatureFlag = 'enabled' | 'legacy-enabled' | false;
